export const make = (value, previous) => ({
  value,
  previous
});
